import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.3327 10.0007C18.3327 12.084 15.8327 16.6673 9.99935 16.6673C4.16602 16.6673 1.66602 12.084 1.66602 10.0007C1.66602 7.91732 4.16602 3.33398 9.99935 3.33398C15.8327 3.33398 18.3327 7.91732 18.3327 10.0007Z",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.4993 10.0007C12.4993 11.3814 11.3801 12.5007 9.99935 12.5007C8.6186 12.5007 7.49935 11.3814 7.49935 10.0007C7.49935 8.6199 8.6186 7.50065 9.99935 7.50065C11.3801 7.50065 12.4993 8.6199 12.4993 10.0007Z",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgEye;
